import { withClassName } from 'lp-hoc'

const StatsList = withClassName('stats')('ul')

export default StatsList
